import React from 'react';
import {
  TextButtonPriority as TEXT_BUTTON_PRIORITY,
  TextButton,
  Tooltip,
  TooltipSkin,
} from 'wix-ui-tpa/cssVars';
import { classes } from './ParticipantActionButton.st.css';
import { ParticipantActionButtonDataHooks } from './dataHooks';

export interface ParticipantActionButtonProps {
  label: string;
  icon: React.ReactElement;
  onClick: () => void;
  disabled?: boolean;
  /** When provided, a tooltip explains why the button is disabled. */
  tooltipContent?: string;
  dataHook?: string;
}

const ParticipantActionButton: React.FC<ParticipantActionButtonProps> = ({
  label,
  icon,
  onClick,
  disabled,
  tooltipContent,
  dataHook,
}) => {
  const button = (
    <TextButton
      priority={TEXT_BUTTON_PRIORITY.primary}
      className={classes.button}
      data-hook={dataHook}
      disabled={disabled}
      onClick={onClick}
      prefixIcon={icon}
    >
      {label}
    </TextButton>
  );

  return (
    <div className={classes.root}>
      {tooltipContent ? (
        <Tooltip
          skin={TooltipSkin.Wired}
          content={tooltipContent}
          minWidth={200}
          data-hook={ParticipantActionButtonDataHooks.TOOLTIP}
        >
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </div>
  );
};

export default ParticipantActionButton;
